import { render, staticRenderFns } from "./Telescope.vue?vue&type=template&id=09e45c17&"
import script from "./Telescope.vue?vue&type=script&lang=js&"
export * from "./Telescope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports